import React from 'react'
// import { Card, Col, Row } from 'react-bootstrap'
import emptyImg from '../../assets/images/no_data.jpg'

const Empty = () => {
    return (
        <div>
            {/* <Card> */}
                <div className='empty-container'>
                    <div className="img-container">
                    {/* <Row >
                        <Col sm="12"> */}
                        <img src={emptyImg} alt="" />
                        <div className='empty-title'>No Record Found</div>
                        {/* </Col>
                    </Row> */}
                    </div>

                </div>
            {/* </Card> */}
        </div>
    )
}

export default Empty